import { Icon, Text } from '@fluentui/react';

import { type S3Object } from '../../../../drive/types';
import { isDirectory } from '../../helpers';
import { getDisplayName, getIconName, getTargetPath } from './utils';

interface DirectoryItemProps {
  item: S3Object;
  currentPath: string;
  onNavigate: (path: string) => void;
}

export const DirectoryItem = ({ item, currentPath, onNavigate }: DirectoryItemProps) => {
  const isDir = (item.Key && isDirectory(item.Key)) || item.isParentDirectory;
  const displayName = getDisplayName(item, currentPath);
  const targetPath = getTargetPath(item, currentPath);

  return (
    <div
      style={{
        padding: '8px 12px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderBottom: '1px solid #f0f0f0',
      }}
      onClick={() => {
        if (isDir) onNavigate(targetPath);
      }}
    >
      <Icon iconName={getIconName(item)} style={{ fontSize: '16px' }} />
      <Text variant="medium">{displayName}</Text>
    </div>
  );
};
